import { Api } from '@/api/api.client';
import { uploadFile } from '@/api/resources/file.api';
import { FileUploadType } from '@/api/generated/api.enum';
import type { Components } from '@/api/generated/api';
import type { IEntryAttachmentTarget } from 'common/enum/entry.attachment.enum';

export function fetchEntryAttachments(
  target: IEntryAttachmentTarget,
  afterId?: number,
): Promise<Components.Schemas.EntryAttachmentResponseDto> {
  return Api.Routes.EntryAttachment.list({ ...target, afterId });
}

export async function uploadEntryAttachment(
  target: IEntryAttachmentTarget,
  file: File,
  thumbnail: File | null,
): Promise<void> {
  const uploaded = await uploadFile(FileUploadType.entryAttachment, file, thumbnail);
  await Api.Routes.EntryAttachment.attachFile(target, { fileId: uploaded.id });
}

export async function removeEntryAttachment(target: IEntryAttachmentTarget, attachmentId: number): Promise<void> {
  await Api.Routes.EntryAttachment.removeFile({ ...target, attachmentId });
}
